import React, { useState } from 'react';
import Icon from '../../components/AppIcon';

const ACCENT = '#F97316';

const canalesMarketing = [
  { canal: 'Instagram', icon: 'Instagram', color: '#E1306C', desc: 'Posts, Stories, Reels', estado: 'No conectado' },
  { canal: 'Facebook', icon: 'Facebook', color: '#1877F2', desc: 'Publicaciones, Eventos', estado: 'No conectado' },
  { canal: 'Web / Blog', icon: 'Globe', color: '#A78BFA', desc: 'Contenido web, SEO', estado: 'Futuro' },
];

const tiposContenido = [
  { tipo: 'Producto Destacado', icon: 'Star', color: '#FBBF24', desc: 'Jamones, embutidos, loncheados' },
  { tipo: 'Oferta / Promoción', icon: 'Tag', color: '#34D399', desc: 'Precios especiales, temporada' },
  { tipo: 'Detrás de las cámaras', icon: 'Camera', color: '#60A5FA', desc: 'Proceso de corte, sala' },
  { tipo: 'Receta / Inspiración', icon: 'ChefHat', color: '#F472B6', desc: 'Ideas con nuestros productos' },
  { tipo: 'Historia de marca', icon: 'BookOpen', color: '#A78BFA', desc: 'Tradición, artesanía, origen' },
  { tipo: 'Temporada / Festividad', icon: 'Calendar', color: ACCENT, desc: 'Navidad, verano, eventos' },
];

const diasSemana = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

const ComercialMarketing = () => {
  const [vistaCalendario, setVistaCalendario] = useState(false);

  return (
    <div className="min-h-screen px-4 py-6 md:px-8"
      style={{ background: 'linear-gradient(135deg, #0A0A0A 0%, #111111 50%, #0D0D0D 100%)' }}>

      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <nav className="flex items-center gap-2 text-xs font-oranienbaum text-white/30 mb-2">
            <span>🤝 Comercial</span>
            <Icon name="ChevronRight" size={12} />
            <span className="text-white/60">Marketing</span>
          </nav>
          <div className="flex items-center gap-3 mb-1">
            <span className="text-2xl">📱</span>
            <h1 className="font-oranienbaum font-bold text-white text-2xl md:text-3xl tracking-wide">Marketing Digital</h1>
          </div>
          <p className="font-oranienbaum text-white/40 text-sm ml-10">Contenido · Redes Sociales · Calendario Editorial</p>
        </div>
        <div className="flex flex-col items-end gap-2">
          <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg"
            style={{ background: 'rgba(249,115,22,0.08)', border: '1px solid rgba(249,115,22,0.20)' }}>
            <div className="w-1.5 h-1.5 rounded-full bg-orange-400 animate-pulse" />
            <span className="font-oranienbaum text-orange-400 text-xs tracking-widest uppercase">Meta no conectado todavía</span>
          </div>
          <div className="flex gap-2">
            <button onClick={() => setVistaCalendario(false)}
              className={`px-3 py-1.5 rounded-lg text-xs font-oranienbaum transition-all ${!vistaCalendario ? 'font-semibold' : 'text-white/50 hover:text-white/80'}`}
              style={!vistaCalendario ? { background: ACCENT, color: '#0A0A0A' } : { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)' }}>
              Vista General
            </button>
            <button onClick={() => setVistaCalendario(true)}
              className={`px-3 py-1.5 rounded-lg text-xs font-oranienbaum transition-all ${vistaCalendario ? 'font-semibold' : 'text-white/50 hover:text-white/80'}`}
              style={vistaCalendario ? { background: ACCENT, color: '#0A0A0A' } : { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)' }}>
              Calendario
            </button>
          </div>
        </div>
      </div>

      {/* Aviso IA */}
      <div className="rounded-xl p-4 mb-6 flex items-start gap-3"
        style={{ background: 'rgba(167,139,250,0.06)', border: '1px solid rgba(167,139,250,0.15)' }}>
        <Icon name="Bot" size={16} className="text-purple-400 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-oranienbaum text-purple-400 font-semibold text-sm mb-0.5">IA para generación de contenido</p>
          <p className="font-oranienbaum text-white/45 text-xs leading-relaxed">
            La IA podrá generar textos, ideas y sugerencias de contenido. <strong className="text-white/60">Nunca inventará productos, precios o stock.</strong> Toda la información de productos y disponibilidad procederá del ERP.
          </p>
        </div>
      </div>

      {!vistaCalendario ? (
        <>
          {/* Canales */}
          <div className="mb-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1 h-5 rounded-full" style={{ background: ACCENT }} />
              <Icon name="Radio" size={15} style={{ color: ACCENT }} />
              <span className="font-oranienbaum font-semibold text-white/80 text-sm tracking-wide uppercase">Canales de Marketing</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {canalesMarketing?.map(c => (
                <div key={c?.canal} className="rounded-xl p-5"
                  style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center"
                        style={{ background: `${c?.color}15`, border: `1px solid ${c?.color}25` }}>
                        <Icon name={c?.icon} size={20} style={{ color: c?.color }} />
                      </div>
                      <div>
                        <p className="font-oranienbaum text-white/80 font-semibold text-sm">{c?.canal}</p>
                        <p className="font-oranienbaum text-white/35 text-xs">{c?.desc}</p>
                      </div>
                    </div>
                    <span className="font-oranienbaum text-xs px-2 py-0.5 rounded-full"
                      style={{ background: 'rgba(255,255,255,0.05)', color: 'rgba(255,255,255,0.30)', border: '1px solid rgba(255,255,255,0.08)' }}>
                      {c?.estado}
                    </span>
                  </div>
                  <div className="grid grid-cols-3 gap-2">
                    {['Publicaciones', 'Seguidores', 'Alcance']?.map(m => (
                      <div key={m} className="rounded-lg p-2 text-center"
                        style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)' }}>
                        <p className="font-oranienbaum text-white/60 font-bold text-lg">—</p>
                        <p className="font-oranienbaum text-white/25 text-xs">{m}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Tipos de contenido */}
          <div className="mb-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1 h-5 rounded-full bg-pink-400" />
              <Icon name="Palette" size={15} className="text-pink-400" />
              <span className="font-oranienbaum font-semibold text-white/80 text-sm tracking-wide uppercase">Tipos de Contenido</span>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
              {tiposContenido?.map(t => (
                <div key={t?.tipo} className="rounded-xl p-4 flex flex-col gap-2 cursor-pointer transition-all hover:scale-[1.02]"
                  style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
                  <div className="w-9 h-9 rounded-xl flex items-center justify-center"
                    style={{ background: `${t?.color}15`, border: `1px solid ${t?.color}25` }}>
                    <Icon name={t?.icon} size={17} style={{ color: t?.color }} />
                  </div>
                  <p className="font-oranienbaum font-semibold text-white/75 text-xs">{t?.tipo}</p>
                  <p className="font-oranienbaum text-white/30 text-xs leading-tight">{t?.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Próximas publicaciones vacías */}
          <div className="rounded-xl overflow-hidden"
            style={{ border: '1px solid rgba(255,255,255,0.07)' }}>
            <div className="px-4 py-3 flex items-center justify-between"
              style={{ background: 'rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
              <span className="font-oranienbaum text-white/60 text-sm font-semibold">Próximas Publicaciones</span>
              <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg font-oranienbaum text-xs font-semibold transition-all"
                style={{ background: ACCENT, color: '#0A0A0A' }}>
                <Icon name="Plus" size={12} />
                Planificar
              </button>
            </div>
            <div className="flex flex-col items-center justify-center py-12"
              style={{ background: 'rgba(255,255,255,0.01)' }}>
              <Icon name="CalendarDays" size={28} className="text-white/15 mb-3" />
              <p className="font-oranienbaum text-white/30 text-sm">Sin publicaciones planificadas</p>
              <p className="font-oranienbaum text-white/15 text-xs mt-1">Conecta los canales para empezar a planificar contenido</p>
            </div>
          </div>
        </>
      ) : (
        /* Vista Calendario */
        <div className="rounded-xl overflow-hidden"
          style={{ border: '1px solid rgba(255,255,255,0.07)' }}>
          <div className="px-4 py-3 flex items-center justify-between"
            style={{ background: 'rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
            <span className="font-oranienbaum text-white/60 text-sm font-semibold">Calendario Editorial — Septiembre 2026</span>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-7 gap-2 mb-2">
              {diasSemana?.map(d => (
                <div key={d} className="text-center font-oranienbaum text-white/30 text-xs py-1 uppercase tracking-wide">{d}</div>
              ))}
            </div>
            <div className="grid grid-cols-7 gap-2">
              {Array.from({ length: 30 }, (_, i) => (
                <div key={i} className="rounded-lg p-2 min-h-[60px] flex flex-col"
                  style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)' }}>
                  <span className="font-oranienbaum text-white/30 text-xs mb-1">{i + 1}</span>
                </div>
              ))}
            </div>
            <p className="font-oranienbaum text-white/20 text-xs mt-3 text-center">
              Las publicaciones planificadas aparecerán en el calendario cuando se conecten los canales de Meta.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ComercialMarketing;
